import banner from "../../assets/img/service-banner5.avif";
const data = [
  "Designing and implementing full warranty management programs tailored for new and existing facilities",
  "Collecting and analyzing vendor and warranty data",
  "Researching equipment installation dates versus warranty expiration",
  "Integrating warranty data with your CMMS/EAM and Document Management Systems",
  "Mapping business processes to manage warranty claims from issue identification to supplier resolution",
  "Delivering integrated reporting on warranty status and cost avoidance",
  "Training staff to efficiently manage warranty procedures",
  "Establishing quality assurance inspections for repaired and rebuilt assets",
  "Conducting supplier performance reviews, including repair and OEM vendors",
  "Implementing preventive maintenance programs on critical spare parts to preserve warranty validity",
  "Significantly reduced warranty-related expenses",
  "Lower incidence of unnecessary or excessive repair work",
  "Minimized repeat repairs and service visits",
  "Enhanced workshop efficiency and productivity",
  "Improved dealer and customer satisfaction through professional warranty handling",
];
const WarrantyManagement = () => {
  return (
    <>
      <section className="serviceSection sectionPD">
        <div className="container">
          <div className="fisherman-content">
            <h3>
              Warranty Management Solutions to Protect Your Assets and Reduce
              Costs
            </h3>
          </div>

          <div className="serviceDetail">
            <div className="header">
              <img
                src={banner}
                alt="Warranty Management Solutions to Protect Your Assets and Reduce Costs"
                className="img-fluid"
                title="Warranty Management Solutions to Protect Your Assets and Reduce Costs"
              />
              <p>
                There’s nothing more frustrating than investing in costly
                equipment only to experience premature failures before the
                expected lifecycle ends. Many organizations face challenges with
                part-swapping and creating costly redundancies due to unreliable
                vendors. At GGAS Maintenance Tooling &amp; Equipments (GGAS), we
                help clients implement comprehensive warranty management
                programs to recover costs and secure free replacements for
                failed assets.
              </p>
            </div>
            <div className="body">
              <h4>Our Warranty Management Services Include:</h4>
              <ul>
                {data.map((item, i) => {
                  return <li key={i}>{item}</li>;
                })}
              </ul>
            </div>
            <div className="footer">
              <p>
                GGAS warranty management solutions protect your investments
                while optimizing operational efficiency and customer trust.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WarrantyManagement;
